import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { WellbeingFeedbackIcons } from '../../';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const WellbeingFeedbackItem: React.FC<Props> = ({
  item,
  isSimple,
  isExpanded,
}) => (
  <ItemWithTooltip item={item}>
    <WellbeingFeedbackIcons
      item={item}
      isSimple={isSimple}
      isExpanded={isExpanded}
    />
  </ItemWithTooltip>
);

export default WellbeingFeedbackItem;
